import { render, staticRenderFns } from "./ESNotification.vue?vue&type=template&id=2db71deb&"
import script from "./ESNotification.vue?vue&type=script&lang=js&"
export * from "./ESNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports